module.exports = __webpack_public_path__ + "img/biaoqian_chukou.cabe6d04.png";